<template>
  <div class="widget white_box">
    <div class="widget_header">
      <h3 class="tw-text-neutral-900 tw-text-2xl">
        Competitor Backlinks Comparison
      </h3>
      <DefaultButton
        v-if="!editing && !preview"
        size="small"
        as="a"
        :href="competitorsQueryString"
      >
        See more
      </DefaultButton>
      <div
        v-if="editing && !preview"
        class="edit_buttons tw-flex tw-gap-2"
      >
        <DefaultButton
          size="small"
          variant="primary-inverted"
          @click="$parent.edit(widget)"
        >
          Options
        </DefaultButton>

        <DefaultButton
          size="small"
          variant="danger"
          @click="$parent.remove()"
        >
          Delete
        </DefaultButton>
      </div>
    </div>
    <div
      v-if="!loading"
      class="table_wrapper"
    >
      <table class="table_component">
        <thead>
          <tr>
            <td>
            &nbsp;
            </td>
            <td
              v-for="(competitor, index) in competitors"
              :key="index"
              :style="`width: ${70 / competitors.length}%`"
            >
              <span>{{ competitor.id == activeWebsite.id ? 'Your Website' : competitor.simpleUrl }}</span>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              No. of Backlinks
            </td>
            <td
              v-for="(competitor, index) in competitors"
              :key="index"
              :style="`width: ${70 / competitors.length}%`"
              v-html="competitor.extBackLinks"
            />
          </tr>
          <tr>
            <td>
              No. of Linking Domains
            </td>
            <td
              v-for="(competitor, index) in competitors"
              :key="index"
              :style="`width: ${70 / competitors.length}%`"
              v-html="competitor.refDomains"
            />
          </tr>
          <tr>
            <td>
              Trust Flow
            </td>
            <td
              v-for="(competitor, index) in competitors"
              :key="index"
              :style="`width: ${70 / competitors.length}%`"
              v-html="competitor.trustFlow"
            />
          </tr>
          <tr>
            <td>
              Citation Flow
            </td>
            <td
              v-for="(competitor, index) in competitors"
              :key="index"
              :style="`width: ${70 / competitors.length}%`"
              v-html="competitor.citationFlow"
            />
          </tr>
          <tr>
            <td>
              Link Score
            </td>
            <td
              v-for="(competitor, index) in competitors"
              :key="index"
              :style="`width: ${70 / competitors.length}%`"
              v-html="competitor.linkScore"
            />
          </tr>
        </tbody>
      </table>
    </div>

    <div
      v-else
      class="loading_widget_data"
    >
      <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import {mapState} from 'vuex'
import axios from 'axios';
import {buildCompetitionCompareUrl} from "@/composables/competition/competition";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";

export default {
  components: {
    DefaultButton,
  },
  props: {
    widget: {
      type: Object,
      default: null,
    },
    editing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: true,
      competitors: {},
    }
  },
  computed: {
    ...mapState('dashboard', ['activeWebsite', 'uuid', 'preview']),
    competitorsQueryString() {
      return buildCompetitionCompareUrl(this.competitors, this.activeWebsite?.id, {activeTab: 'backlink'});
    },
  },
  watch: {
    'widget.competitors': {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.fetchData();
      },
      deep: true
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      axios.post('/ajax/dashboard/get-widget-data', {
        type: 'competitionBacklinks',
        competitor_ids: this.widget.competitors,
        uuid: this.uuid
      }).then(response => {
        this.competitors = response.data;
        this.loading = false;
      }).catch(error => {
        console.log(error);
      });
    }
  }
}
</script>

<style scoped>
small.green {
  color: #00a651;
}

small.red {
  color: #e50000;
}

small.grey {
  color: #979797;
}

tr td:not(:first-of-type) {
  text-align: center;
}

tr td {
  width: 25%;
}

tr td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
